import { TContentAutomationMockConfig } from './types';

export const isContentAutomationVisible = (config?: TContentAutomationMockConfig) =>
  Array.isArray(config?.documents) && config.documents.length > 0;
